import React from 'react'

const Title = () => {
    return (
        <div className="title">
      <h1>Base Gallery</h1>
      <h2>Your Pictures</h2>
      <p>Drop your picture here to save as memory</p>
    </div>
    )
}

export default Title;
